import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'
import Slider from 'react-slick'

//* utils
import { RichTextWrapper } from '../../../../styles/global'
import { internalLinkHandler } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
// @ts-ignore
import Robot from '../../../../../static/steam-img/orange-robot.png'

//* components
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import VerticalMedia from './verticalMedia'

type Props = {
  verticalTabData: any
  slideNumber: number
  settings: any
  customSlider: any
}

export const VerticalContent: FC<Props> = ({
  verticalTabData,
  slideNumber,
  settings,
  customSlider,
}) => {
  const handleSlideNext = () => {
    if (typeof customSlider !== undefined && customSlider.current) {
      // @ts-ignore
      customSlider.current.slickGoTo((slideNumber + 1) % verticalTabData.panels.length)
    }
  }

  const handleSlidePrev = () => {
    if (typeof customSlider !== undefined && customSlider.current) {
      // @ts-ignore
      customSlider.current.slickGoTo(
        (slideNumber - 1 < 0 ? verticalTabData.panels.length - 1 : slideNumber - 1) %
          verticalTabData.panels.length
      )
    }
  }

  return (
    <Grid className="VerticalTabs__Content-Container" item xs={8}>
      <div className="VerticalTabs__Content-Outer">
        <WrapperImage
          className="VerticalTabs__Robot"
          src={Robot}
          alt="robot"
          width={282}
          height={315}
          threshold={650}
        />

        <div className="VerticalTabs__Circle" />
        <div className="VerticalTabs__Slider-Nav-Container">
          <Button
            type="icon"
            clickHandler={handleSlidePrev}
            className="VerticalTabs__Slider-Prev-Button"
            ariaLabel="Previous slide"
            arrowOrientation="left"
            theme={'light'}
          />

          <div className="VerticalTabs__Slider-Slide-Position">
            <Typography type="leadXS">
              {slideNumber + 1} / {verticalTabData.panels.length}
            </Typography>
          </div>

          <Button
            type="icon"
            clickHandler={handleSlideNext}
            className="VerticalTabs__Slider-Next-Button"
            ariaLabel="Next slide"
            arrowOrientation="right"
            theme={'light'}
          />
        </div>

        <div className="VerticalTabs__Content-Inner">
          {/* @ts-ignore */}
          <Slider
            {...settings}
            className="VerticalTabs__Slider"
            ref={(slider: any) => (customSlider.current = slider)}>
            {verticalTabData.panels.map((item: any, idx: number) => {
              if (!item) return null
              const itemHref = item.cta?.internalLink
                ? internalLinkHandler(item.cta.internalLink)
                : item.cta?.externalUrl || ''

              return (
                <div className="VerticalTabs__Slider-Item" key={`VerticalTabs__Slider-Item-${idx}`}>
                  <div>
                    {item.media && <VerticalMedia media={item.media} />}

                    {item.headline && (
                      <Typography className="VerticalTabs__Item-Header" type="header3">
                        {item.headline}
                      </Typography>
                    )}

                    {item.body && (
                      <RichTextWrapper $type="body" className="VerticalTabs__Item-Body">
                        {renderRichText(item.body)}
                      </RichTextWrapper>
                    )}

                    {item.cta?.text && (
                      <Button
                        icon={true}
                        href={itemHref}
                        text={item.cta.text}
                        type="text-link"
                        size="small"
                        theme="light"
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </div>
    </Grid>
  )
}
